import * as icons from '@mui/icons-material';

function getIcon(iconName, defaultIcon = icons.Help) {
    return icons[iconName] ? icons[iconName] : defaultIcon;
}
export default getIcon;
